import { createFileRoute, redirect } from "@tanstack/react-router";
import { studyGroupsApi } from "@/lib/humhub-api/studyGroups";

export const Route = createFileRoute("/")({
  beforeLoad: async () => {
    // 1. localStorage から studyGroup データを取得してチェック
    const studyGroupData = localStorage.getItem("studyGroup");

    if (studyGroupData) {
      try {
        const parsed = JSON.parse(studyGroupData);
        if (parsed.studyGroupId && typeof parsed.studyGroupId === "number") {
          // localStorage から有効なデータが取得できた場合
          throw redirect({
            to: "/study-group/$study-group-id/stream",
            params: { "study-group-id": String(parsed.studyGroupId) },
            replace: true,
          });
        }
      } catch (parseError) {
        // JSON パースエラーは無視して次の処理に進む
        if (!(parseError && typeof parseError === "object" && "isRedirect" in parseError)) {
          console.warn("Invalid studyGroup data in localStorage, falling back to API");
        } else {
          // リダイレクトエラーは再スロー
          throw parseError;
        }
      }
    }

    // 2. localStorage にデータがない、または無効な場合は API から取得
    try {
      const response = await studyGroupsApi.getMyStudyGroups("newer", 1, 1);

      if (response.results && response.results.length > 0) {
        const firstGroup = response.results[0];

        // API から取得したデータでリダイレクト
        throw redirect({
          to: "/study-group/$study-group-id/stream",
          params: { "study-group-id": String(firstGroup.id) },
          replace: true,
        });
      }
    } catch (apiError) {
      // リダイレクトエラーは再スロー
      if (apiError && typeof apiError === "object" && "isRedirect" in apiError) {
        throw apiError;
      }
      // API エラーは無視して次の処理に進む
      console.warn("Failed to fetch study groups from API, redirecting to event-search");
    }

    // 3. すべて失敗した場合は event-search にリダイレクト
    throw redirect({
      to: "/event-search",
      replace: true,
    });
  },
  component: () => <div>Redirecting...</div>,
});
